import { Gruppe } from '../../../../../../projects/kiene-core/src/lib/components/gruppen/classes/gruppe';
import { Component, Inject, Input, OnInit } from '@angular/core';
import { Subscription } from 'rxjs';
import { MatDialog } from '@angular/material/dialog';
import { GruppeInformationenDialogComponent } from '../../../../../../src/app/gruppen/gruppe-informationen-dialog/gruppe-informationen-dialog.component';
import { API_BASE_URL_SERVICE } from '../../../../../../projects/kiene-core/src/lib/kiene-core.config';
import { MessageService } from '../../../../../../projects/kiene-core/src/lib/services/message-service/message.service';
import { KieneBackendApiService } from '../../../../../../projects/kiene-core/src/lib/services/backend-api/kiene-backend-api.service';
import { HttpParams } from '@angular/common/http';
import { GruppeBewegung } from '../../../../../../projects/kiene-core/src/lib/components/gruppen/schweine/tod-melden-dialog/tod-melden-dialog';

@Component({
    selector: 'kiene-details-verlauf-statisiken',
    templateUrl: './details-verlauf-statisiken.component.html',
    styleUrls: ['./details-verlauf-statisiken.component.scss'],
})
export class DetailsVerlaufStatisikenComponent implements OnInit {
    gruppeSubscription: Subscription;
    gruppenBewegungen: GruppeBewegung[] = [];

    @Input() gruppe: Gruppe;

    constructor(
        private dialog: MatDialog,
        @Inject(API_BASE_URL_SERVICE) private apiBaseUrl: string,
        private messageService: MessageService,
        private api: KieneBackendApiService,
    ) {}

    ngOnInit(): void {
        console.log('gruppe', this.gruppe);
        this.ladeVerlauf();
    }

    openGruppeInformationenDialog() {
        this.dialog
            .open(GruppeInformationenDialogComponent, { width: '50vw', data: { gruppe_id: this.gruppe.gruppe_id } })
            .afterClosed()
            .subscribe({
                next: () => {
                    this.loadGruppe();
                },
            });
    }

    loadGruppe() {
        this.gruppeSubscription?.unsubscribe();
        this.gruppeSubscription = this.api
            .getByIdAlternative(
                this.apiBaseUrl + 'gruppe/read_one_kundenportal.php',
                'gruppe_id',
                this.gruppe?.gruppe_id,
            )
            .subscribe({
                next: (gruppe: Gruppe) => {
                    this.gruppe = gruppe;
                },
                error: err => {
                    this.messageService.errorMessage('Gruppe konnte nicht geladen werden!', err);
                },
            });
    }

    /**
     * s1 - s2 ==> (+/- {result})
     * @param s1
     * @param s2
     * @param options - asPercentage: boolean
     */
    getDifferenceString(s1: number | undefined, s2: number | undefined, options?: { asPercentage: boolean }): string {
        if (s1 && s2) {
            let erg: number;
            if (options?.asPercentage) {
                erg = Number(((s1 / s2) * 100).toFixed(1));
            } else {
                erg = s1 - s2;
            }
            if (erg > 0) {
                return `(${options?.asPercentage ? '' : '+'}${erg.toString()}${options?.asPercentage ? '%' : ''})`;
            } else if (erg < 0) {
                return `(${erg.toString()}${options?.asPercentage ? '%' : ''})`;
            } else {
                return '';
            }
        }
        return '';
    }

    private ladeVerlauf() {
        let params = new HttpParams();
        params = params.append('gruppe_id', this.gruppe.gruppe_id.toString());
        params = params.append('order by', 'datum ASC');
        this.api.getAll(this.apiBaseUrl + 'gruppe_bewegung/read.php', params).subscribe({
            next: response => {
                if (response) {
                    this.gruppenBewegungen = response.records;
                }
            },
            error: err => {
                this.messageService.errorMessage('Fehler', err);
            },
        });
    }

    // 1: Zugang, 2: Abgang/Ausstallen, 3: Tod, (4: Geburt, 5: Export,) 6: Umstallen

    getIcon(bewegung_typ: number) {
        switch (bewegung_typ) {
            case 1:
                return 'arrow_circle_right';
            case 2:
                return 'arrow_circle_left';
            case 3:
                return 'local_hospital';
            case 4:
                return 'cake';
            case 5:
                return 'local_shipping';
            case 6:
                return 'swap_horizontal_circle';
            default:
                return 'info';
        }
    }

    getIconColor(bewegung_typ: number) {
        switch (bewegung_typ) {
            case 1:
                return 'green';
            case 2:
                return 'red';
            case 3:
                return 'black';
            case 4:
                return 'orange';
            default:
                return 'gray';
        }
    }

    getBewegungstyp(bewegung_typ: number) {
        let typ = '';
        switch (bewegung_typ) {
            case 1:
                typ = 'Zugang';
                break;
            case 2:
                typ = 'Abgang';
                break;
            case 3:
                typ = 'Tod';
                break;
            case 4:
                typ = 'Geburt';
                break;
            case 5:
                typ = 'Export';
                break;
            case 6:
                typ = 'Umstallen';
                break;
            default:
                typ = 'info';
        }
        return typ;
    }
}
